<template>
  <div class="background-01">
    <v-container class="adorn-bottom-left" pb-5>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="davi-curs font-red big-font animated fadeInLeft">
            <image-app :imaSize="80" imaSrc="design/banco3-1-1" imaAlt=""></image-app> Si: </h1>
        </v-flex>
        <v-flex xs12 class="text-xs-center">
          <ui-simple-lsc  :vidTittle="'Ingresos mayores que gastos'" videoEmbed="ADMINISTRACIONDINERO44IngresosMayoresQueGastos.mp4"></ui-simple-lsc>
        </v-flex>
      </v-layout>

      <v-layout row wrap justify-center class="animated fadeIn dura_1">
        <v-flex xs12 sm12 md12>
          <p>
            <strong> El total de sus ingresos es mayor que el total de sus gastos</strong>
          </p>
        </v-flex>
      </v-layout>

      <div aria-label="Los ingresos son mayores que los gastos" class="mayot-menor-que borde-dashed animated fadeIn dura_2">
        <v-layout aria-hidden="true" row wrap justify-center pt-3 pl-4 pr-4>
          <v-flex sm4 class="aligner animated fadeInLeft dura_2">
            <p class="davi-curs">Ingresos</p>
          </v-flex>
          <v-flex sm4>
            <p class="font-red signo animated bounceIn dura_3">
              ></p>
          </v-flex>
          <v-flex sm4 class="aligner animated fadeInRight dura_2">
            <p class="davi-curs">Gastos</p>
          </v-flex>
        </v-layout>
      </div>
      <v-layout row wrap justify-center mt-5 class="animated fadeInLeft dura_4">
        <v-flex xs12 sm2 hidden-xs-only>
          <image-app :imaSize="80" imaSrc="design/banco3-1-1" imaAlt=""></image-app>
        </v-flex>
        <v-flex xs12 sm10>
          <ui-title-one titleAccess="Lo está haciendo muy bien, está optimizando su dinero, y puede ahorrar y construir patrimonio." titleLevel="p">
            <template slot="partOne"> Lo está haciendo muy bien, </template>
            <template slot="partTwo">está optimizando su dinero y puede</template>
            <template slot="partThree"> ahorrar y construir patrimonio.</template>
          </ui-title-one>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>

<style lang="scss" scoped>
.big-font {
  font-size: 3rem;
}
</style>



// WEBPACK FOOTER //
// davivienda-44.vue?206f8518